import ToolStylus from './ToolStylus';
import ToolComment from './ToolComment';

class ToolStylusComment extends ToolStylus {
  static toolName = 'Comment';

  static action({ controller }) {
    controller.actionSetStylus(controller.stylusComment);
  }

  static available({ controller, selection }) {
    return ToolComment.available({ controller, selection });
  }
}

export default ToolStylusComment;
